import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
    navBar: {
        backgroundColor: "#3474b4"
    },
    title: {
        margin: "0 30px 0 10px !important",
        padding: "5px 5px",
        fontSize: "1rem"
    },
    flow: {
        flexGrow: 1
    }
});